module.exports = __webpack_public_path__ + "static/flags/CM-06f2b30980f8aa5ca1f893e9a86c7978.gif";